import {
  Box,
  Grid,
  Button,
  Paper,
  InputBase,
  MenuItem,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useStockTransferList } from "api/hooks/inventory";
import { useSelector } from "react-redux";
import { useState } from "react";
import FixedSizeDialog from "components/fixedSizeDialog";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import { requester } from "api/pesabackend";
import StockTransferViewForm from "../forms/stockTransferViewForm";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { currencyFormatter } from "utilities/currencyFormatter";

export default function StockTransferCreateTable({ setIsSuccess, setIsFailed }) {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { stockTransferList, isLoadingStockTransferList, setSearch, setFilter, setNewStockTransferData } = useStockTransferList(1, 'send',business_branch_id);

  const [openView, setOpenView] = useState(false);
  const [viewData, setViewData] = useState({});
  const [showFiter, setShowFilter] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const [searchContent, setSearchContent] = useState("");

  // const handleClickEditOpen = async (e) => {
  //   const response = await requester.get(
  //     `/inventory/stock_transfer/get/${e.target.value}`
  //   );
  //   if (response.status === 200) {
  //     navigate("/editStockTransferForm", { state: response.data.data });
  //   }
  // };


  const handleClickDeleteOpen = async (e) => {
    const response = await requester.get(
      `/inventory/stock_transfer/get/${e.target.value}`
    );
    if (response.status === 200) {
    }
  };

  // const handleClickDelete = async () => {
  // const response = await requester.post(`/inventory/stock_transfer/delete/${clickedItem}`);
  // setIsSuccess(true)
  // setNewPurchaseData(true)
  //  // };

  const handleClickView = async (e) => {
    const response = await requester.get(
      `/inventory/stock_transfer/get_form/${e.target.value}`
    );
    if (response.status === 200) {
      // navigate("/PayslipViewForm", { state: response.data.data });
      setViewData(response.data.data);
      setOpenView(true);
    }
  };

  const handleClickViewClose = async (e) => {
    setOpenView(false);
  };

  const handleSearchInput = async (e) => {
    setSearchContent(e.target.value);
  };

  const handleClickSearch = async () => {
    setSearch(searchContent);
  };

  const handleChangeFilter = async (e) => {
    if (e.target.value === "THIS MONTH") {
      setStartDate(moment().startOf("month").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("month").format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "CUSTOM") {
      setShowFilter(true);
    }
  };

  const handleClickFilter = () => {
    setFilter({ start: startDate, end: endDate });
  };

  const columns = [
    { label: "Date Created",    width: 150 },
    { label: "Transfer Number", width: 120 },
    { label: "Transfer Date",   width: 150 },
    { label: "Grand Total",     align: "right" },
    { label: "Transferred To",  width: 150 },
    { label: "Created By" },
    { label: "Actions",         align: "center", width: 150 },
  ];

  return (
    <Box>
      <h4>Stock Transfer List</h4>
      <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <Grid xs={3}>
            <Paper
              sx={{
                my: "10px",
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                minWidth: 170,
                maxWidth: 300,
              }}
            >
              <InputBase
                placeholder="Search Employee Name"
                value={searchContent}
                onChange={handleSearchInput}
                sx={{ ml: 1, flex: 1 }}
              />
              <IconButton onClick={handleClickSearch}>
                <SearchIcon />
              </IconButton>
            </Paper>
          </Grid>

          <Grid xs={6}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                // m: "4px",
              }}
            >
              <h4>FILTER BY PERIOD:</h4>
              <Paper
                sx={{
                  m: "10px",
                  display: "flex",
                  alignItems: "center",
                  minWidth: 130,
                  maxWidth: 200,
                }}
              >
                <TextField
                  label="PERIOD"
                  select
                  defaultValue="THIS MONTH"
                  size="small"
                  onChange={(e) => {
                    handleChangeFilter(e);
                  }}
                  sx={{
                    minWidth: 50,
                    width:'100%'
                  }}
                >
                  <MenuItem value="THIS MONTH">THIS MONTH</MenuItem>
                  <MenuItem value="CUSTOM">CUSTOM</MenuItem>
                </TextField>
              </Paper>
              
              {showFiter ? (
                <>
                  <Paper
                    sx={{
                      m: "10px",
                      display: "flex",
                      alignItems: "center",
                      minWidth: 130,
                      maxWidth: 200,
                    }}
                  >
                    <TextField
                      label="Start Date"
                      type="date"
                      defaultValue={startDate}
                      size="small"
                      onChange={(e) => setStartDate(e.target.value)}
                      // sx={{
                      //   m: "10px",
                      //   backgroundColor: "white",
                      // }}
                      inputProps={{
                        max: endDate,
                      }}
                    />
                  </Paper>
                  
                  <Paper
                    sx={{
                      m: "10px",
                      display: "flex",
                      alignItems: "center",
                      minWidth: 130,
                      maxWidth: 200,
                    }}
                  >
                    <TextField
                      label="End Date"
                      type="date"
                      defaultValue={endDate}
                      size="small"
                      onChange={(e) => setEndDate(e.target.value)}
                      // sx={{
                      //   m: "10px",
                      //   backgroundColor: "white",
                      // }}
                      inputProps={{
                        min: startDate,
                      }}
                    />
                  </Paper>
                  
                </>
              ) : null}
              <Button
                variant="contained"
                size="small"
                sx={{
                  m: "9px",
                }}
                onClick={() => handleClickFilter()}
              >
                FILTER
              </Button>
            </Box>
          </Grid>
          <Grid xs={3} sx={{ textAlign: "right" }}>
            <Button variant="contained" onClick={() => navigate("/stockTransferForm")}>
              RECORD STOCK TRANSFER
            </Button>
            
          </Grid>
        </Grid>
      </Box>

      <ReportTable
        columns={columns}
        rows={stockTransferList}
        loading={isLoadingStockTransferList}
        emptyMessage="No data found"
        renderRow={(row, index) => (
          <RRow key={row.id} index={index}>
            <RCell>{moment(row.date_added).format("LLL")}</RCell>
            <RCell>{row.id}</RCell>
            <RCell>{moment(row.transfer_date).format("LL")}</RCell>
            <RCell align="right">{currencyFormatter(parseFloat(row.grand_total))}</RCell>
            <RCell>{row.transferred_to.branch_name}</RCell>
            <RCell>{row.added_by.first_name} {row.added_by.last_name}</RCell>
            <RCell align="center">
              <Button value={row.id} size="small" onClick={(e) => handleClickView(e)}>View</Button>
              {row.status === 0 ? (
                <Button value={row.id} size="small" onClick={(e) => handleClickDeleteOpen(e)}>Delete</Button>
              ) : null}
            </RCell>
          </RRow>
        )}
      />

      <FixedSizeDialog
        dialogHeading="View Stock Transfer Form"
        open={openView}
        handleClose={handleClickViewClose}
        negativeResponse="Cancel"
        maxWidth={"md"}
        scroll={"body"}
        content={
          <Box p="1rem" borderRadius="0.5rem">
            <StockTransferViewForm viewData={viewData} setNewStockTransferData={setNewStockTransferData} setIsSuccess={setIsSuccess} setIsFailed={setIsFailed} setOpenView={setOpenView}/>
          </Box>
        }
      />
    </Box>
  );
}
